export default {"src":"/_next/static/media/heart-smile-icon.b0faa7b4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};